'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["isInverted", "className"];
/**
 * Signet
 *
 * Renders the HAUSGOLD signet
 */
var Signet = react.forwardRef(function (_ref, ref) {
  var isInverted = _ref.isInverted,
    className = _ref.className,
    rest = _objectWithoutProperties__default["default"](_ref, _excluded);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.svg, _extends__default["default"]({
    __css: {
      w: '100%',
      h: '100%'
    },
    className: utils.cx('chakra-signet', className)
  }, rest, {
    viewBox: "0 0 147 140",
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement("defs", null, /*#__PURE__*/React__default["default"].createElement("linearGradient", {
    x1: "-476.229%",
    y1: "70.085%",
    x2: "268.072%",
    y2: "24.965%",
    id: "a"
  }, /*#__PURE__*/React__default["default"].createElement("stop", {
    stopColor: "#00A1F2",
    offset: "0%"
  }), /*#__PURE__*/React__default["default"].createElement("stop", {
    stopColor: "#2B8AF6",
    offset: "100%"
  }))), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M59.772 139.45c2.957-1.69 5.922-3.367 8.869-5.076 9.035-5.239 17.322-11.526 25.52-17.943 7.522-5.887 14.917-11.918 21.57-18.779 3.77-3.889 7.43-7.889 11.032-11.934.961-1.08 1.174-.852 1.561.29 5.453 16.068 10.927 32.13 16.384 48.196.464 1.369.758 2.798 1.283 4.142.493 1.261 0 1.531-1.125 1.415-.05-.005-.1 0-.151 0h-84.81l-.133-.31",
    fill: isInverted ? '#fff' : 'url(#a)'
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.314 139.984c-1.761 0-3.524-.035-5.283.014-.955.026-1.214-.17-.91-1.197 2.575-8.714 4.832-17.53 7.682-26.151 4.805-14.527 9.712-29.031 15.06-43.363 6.066-16.253 13.162-32.07 22.427-46.81 3.458-5.502 7.284-10.739 12.023-15.227 2.97-2.812 6.224-5.243 10.18-6.517C73.482-1.195 78.53.883 83.112 4.6c6.047 4.905 10.52 11.148 14.67 17.643 6.151 9.63 11.123 19.887 15.957 30.217.416.888.35 1.515-.296 2.297-7.474 9.046-15.61 17.473-24.124 25.522-13.76 13.01-28.202 25.24-43.453 36.453-10.506 7.725-21.375 14.956-32.043 22.462-1.35.95-2.754.751-4.187.785-1.106.025-2.214.005-3.32.005",
    fill: "#F2686D"
  }));
});
Signet.displayName = 'Signet';
exports.Signet = Signet;